import React from 'react';

const Footer = () => {
  return (
    <div className='Footer'>
        <div className='container'>
            <div className='Footercontain'>
                <img src='./images/payment.png' alt=''/>
                <p>Copyright © 2022 <a href="./">Hamro<span>Drink</span>.</a> All Rights Reserved.</p>
            </div>
        </div>
    </div>
  )
}

export default Footer;